<template>
  <div class="dynamic-tables">
    <h2 class="page-title text-center">Rencana Aksi UPT</h2>
    <Widget customHeader>
      <div class="mb-3">
        <b-button v-if="!isCentralVerifier" variant="primary" @click="tambahRencanaAksi">
          <i class="fa fa-plus"></i> Tambah
        </b-button>
      </div>
      <table class="table" style="width: 100%">
        <thead>
          <tr>
            <th>Prioritas</th>
            <th>Nama UPT</th>
            <th>No. KKPRL</th>
            <th>Nama Pemegang</th>
            <th>Metode</th>
            <th>Tanggal Penilaian</th>
            <th>Status</th>
            <th>Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="data in dataRencanaAksi" :key="data.id">
            <td>
              <span :class="['badge', data.prioritas === 'Ya' ? 'bg-success' : 'bg-secondary']">
                {{ data.prioritas }}
              </span>
            </td>
            <td>{{ data.nama_upt }}</td>
            <td>{{ data.nomor_kkprl }}</td>
            <td>{{ data.nama_pemegang }}</td>
            <td>{{ data.metode }}</td>
            <td>{{ formatDate(data.tanggal_penilaian, 'DD MMMM YYYY') }}</td>
            <td>
              {{ data.status }}
              <span v-if="data.status_verifikasi" class="d-block text-muted">Verifikasi: {{ data.status_verifikasi }}</span>
            </td>
            <td>
              <div class="d-flex flex-column flex-wrap">
                <template v-if="isCentralVerifier">
                  <div>
                    <b-button size="sm" variant="primary" class="mb-2" @click="lihatRencanaAksiUpt(data.id)">
                      Lihat Rencana Aksi UPT
                    </b-button>
                  </div>
                  <div>
                    <b-button size="sm" variant="success" class="mb-2" @click="bukaModalVerifikasi(data)">
                      Verifikasi Rencana Aksi UPT
                    </b-button>
                  </div>
                </template>
                <template v-else>
                  <div>
                    <b-button size="sm" variant="primary" class="mb-2" @click="inputDokumenKelengkapan(data.id)">
                      Input Dokumen Kelengkapan
                    </b-button>
                  </div>
                  <div>
                    <b-button size="sm" variant="success" class="mb-2" @click="submitRencanaAksi(data.id)">
                      Submit Rencana Aksi
                    </b-button>
                  </div>
                  <div>
                    <b-button size="sm" variant="warning" class="mb-2" @click="finalisasiRencanaAksi(data.id)">
                      Finalisasi Rencana Aksi
                    </b-button>
                  </div>
                </template>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </Widget>
    <b-modal ref="modalVerifikasi" title="Verifikasi Rencana Aksi UPT" hide-footer @hidden="resetVerifikasi">
      <b-form-group label="Catatan">
        <ckeditor :editor="wygEditor" v-model="catatanVerifikasi" />
        <small v-if="catatanVerifikasiError" class="text-danger">{{ catatanVerifikasiError }}</small>
      </b-form-group>
      <div class="d-flex justify-content-end">
        <b-button variant="success" class="me-2" @click="prosesVerifikasi('disetujui')">Setujui</b-button>
        <b-button variant="danger" @click="prosesVerifikasi('ditolak')">Tolak</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { formatDate, isVerifikatorPusat } from '@/helper/helpernew'
import { getRencanaAksiUptList } from './mockRencanaAksiUpt'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

export default {
  name: 'RencanaAksiUpt',
  data() {
    return {
      dataRencanaAksi: getRencanaAksiUptList(),
      user: JSON.parse(localStorage.getItem('userPengendalian') || '{}'),
      wygEditor: ClassicEditor,
      selectedRencanaAksi: null,
      catatanVerifikasi: '',
      catatanVerifikasiError: '',
    }
  },
  computed: {
    isCentralVerifier() {
      return isVerifikatorPusat(this.user)
    },
  },
  methods: {
    formatDate,
    lihatRencanaAksiUpt(id) {
      this.$router.push({ name: 'FormRencanaAksiUpt', params: { id } })
    },
    bukaModalVerifikasi(data) {
      this.selectedRencanaAksi = data
      this.catatanVerifikasi = ''
      this.catatanVerifikasiError = ''
      this.$refs.modalVerifikasi.show()
    },
    resetVerifikasi() {
      this.selectedRencanaAksi = null
      this.catatanVerifikasi = ''
      this.catatanVerifikasiError = ''
    },
    prosesVerifikasi(keputusan) {
      const teksCatatan = new DOMParser().parseFromString(this.catatanVerifikasi || '', 'text/html').body.textContent
        .replace(/[\u00a0\u200b]/g, ' ').trim()
      if (keputusan === 'ditolak' && !teksCatatan) {
        this.catatanVerifikasiError = 'Catatan wajib diisi saat menolak Rencana Aksi UPT.'
        return
      }
      this.$set(this.selectedRencanaAksi, 'status_verifikasi', keputusan)
      this.$set(this.selectedRencanaAksi, 'catatan_verifikasi', this.catatanVerifikasi)
      this.$refs.modalVerifikasi.hide()
      this.$bvToast.toast(`Rencana Aksi UPT berhasil ${keputusan}.`, { title: 'Verifikasi berhasil', variant: 'success', solid: true })
    },
    tambahRencanaAksi() {
      this.$router.push({ name: 'TambahRencanaAksiUpt' })
    },
    inputDokumenKelengkapan(id) {
      this.$router.push({ name: 'FormRencanaAksiUpt', params: { id } })
    },
    submitRencanaAksi(id) {
      console.log('Submit Rencana Aksi:', { id })
    },
    finalisasiRencanaAksi(id) {
      console.log('Finalisasi Rencana Aksi:', { id })
    },
  },
}
</script>
